/* Import defaults */
import Vue from 'vue'
import App from '@components/App'

/* Import Definitions */
import router from '@router/Index'
import store from '@store/Index'

/* Import Packages */
import Axios from 'axios'
import Vuex from 'vuex'
import AsyncComputed from 'vue-async-computed'
import PersistedState from 'vuex-persistedstate'
import VeeValidate from 'vee-validate'
import Message from 'vue-flash-message'
import Moment from 'moment'
import VueMoment from 'vue-moment'
import Underscore from 'underscore'
import Lodash from 'vue-lodash'
import Masonry from 'vue-masonry-css'
import Carousel from 'vue-owl-carousel'
import Instagram from 'vue-instagram'
import Scroll from 'vue-scrollto'
import ProductSpinner from 'vue-product-spinner'
import Number from '@chenfengyuan/vue-number-input'
import Meta from 'vue-meta'
import Animate from 'v-animate-css'
import Swiper from 'vue-awesome-swiper'
import Calendar from 'vue-full-calendar'
import Datepicker from 'vue-hotel-datepicker'
import Datetime from 'vue-datetime'
import { VLazyImagePlugin } from 'v-lazy-image'
import * as Maps from 'vue2-google-maps'

/* Styles */
import 'swiper/dist/css/swiper.css'
import 'fullcalendar/dist/fullcalendar.css'
import 'vue-datetime/dist/vue-datetime.css'

/* Settings */
import { sync } from 'vuex-router-sync'
import { Settings } from 'luxon'

sync(store, router)

/* Assign packages */
Vue.use(AsyncComputed)
Vue.use(Vuex)
Vue.use(PersistedState)
Vue.use(VeeValidate)
Vue.use(Underscore)
Vue.use(Lodash)
Vue.use(Masonry)
Vue.use(Instagram)
Vue.use(Meta)
Vue.use(VLazyImagePlugin)
Vue.use(VueMoment)
Vue.use(Animate)
Vue.use(Scroll, { container: "body",  duration: 1000,  easing: "ease",  offset: 0,  force: true,  cancelable: true,  onStart: false,  onDone: false,  onCancel: false,  x: false,  y: true })
Vue.use(Maps, { load: { key: "AIzaSyADe9CNKfMsrGO7TMXiHahfLab94AxxV0A",  libraries: "places" } })
Vue.use(Message, { messageOptions: { timeout: 5000,  important: true,  pauseOnInteract: true } })
Vue.use(Swiper)
Vue.use(Calendar)
Vue.use(Datetime)

/* Assign Components */
Vue.component('Carousel', Carousel)
Vue.component('Number', Number)
Vue.component('ProductSpinner', ProductSpinner)
Vue.component('Datepicker', Datepicker)

/* Setup Axios */
Vue.axios = Axios
Vue.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'
Vue.axios.defaults.headers.common['X-CSRF-TOKEN'] = document.head.querySelector('meta[name="csrf-token"]').content
Vue.axios.defaults.headers.common['Authorization'] = store.state.token
Vue.axios.defaults.headers.common['Content-Type'] = 'multipart/form-data'

/* Define Application prototypes */
Vue.prototype.Axios = Axios
Vue.prototype.Moment = Moment
Vue.prototype.Underscore = Underscore
Vue.prototype.Lodash = _
Vue.prototype.Settings = Settings

/* Router guards */
router.beforeEach((to, from, next) => {
    $('.modal').modal('hide')
    next()
})

/* Production build */
Vue.config.devtools = false
Vue.config.debug = false
Vue.config.silent = true

new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./resources/assets/js/app.js